import { Dispatch, ReactNode, createContext } from "react";

export type ConfirmState = {
  show: boolean;
  title: ReactNode;
  description: ReactNode;
  cancelBtnText?: string;
  confirmBtnText?: string;
};

export type ConfirmEvent = {
  type: "show" | "hide";
  title: ReactNode;
  description: ReactNode;
  cancelBtnText?: string;
  confirmBtnText?: string;
};

export const defaultConfirmState: ConfirmState = {
  show: false,
  title: "",
  description: "",
  cancelBtnText: "",
  confirmBtnText: "",
};

export const ConfirmStateContext =
  createContext<ConfirmState>(defaultConfirmState);
export const ConfirmEventContext = createContext<Dispatch<ConfirmEvent>>(
  () => {},
);
